import React from 'react';
import { Menu, Dropdown, Icon } from 'antd';

import 'antComponentsStyle';

const ThreeVerticalDots = () => (
  <svg viewBox="0 0 29.96 122.88" width="1em" height="1em">
    <path d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z" />
  </svg>
);

const DropdownMenu = ({ trigger, items }) => {
  let triggerEvents;

  if (trigger && Array.isArray(trigger)) {
    triggerEvents = trigger;
  } else if (trigger) {
    triggerEvents = [trigger];
  } else {
    triggerEvents = ['click'];
  }

  return (
    <Dropdown
      placement="bottomRight"
      overlay={
        <Menu>
          {items.map((item, key) => (
            <Menu.Item key={key}>{item}</Menu.Item>
          ))}
        </Menu>
      }
      trigger={triggerEvents}
    >
      <Icon component={ThreeVerticalDots} />
    </Dropdown>
  );
};

export default DropdownMenu;
